import { useDispatch } from 'react-redux';
import { Col, Row, Card, CardHeader, CardBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import {
	getEstablishmentList,
	getEstablishmentQuery,
} from '../../../slices/thunks';
import { Link } from 'react-router-dom';
import AddEditEstablishmentModal from './Add_Edit/AddEditEstablishmentModal';
import DeleteEstablishmentModal from './Delete/DeleteEstablishment';
import { ODataGrid } from '../../../Components/OElements/ODataGrid';
import { toSmartTitleCase } from '../../../utils/toSmartTitleCase';
import { to } from 'react-spring';

const EstablishmentsList = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();

	const selectorEstablishments = createSelector(
		state => state.Establishments,
		establishment => ({
			establishmentList: establishment.establishmentList,
			isLoadingList: establishment.isLoadingList,
			isEstablishmentSuccess: establishment.isEstablishmentSuccess,
			error: establishment.error,
			isAdding: establishment.isAdding,
			isAdded: establishment.isAdded,
			isAddError: establishment.isAddError,
			isUpdating: establishment.isUpdating,
			isUpdated: establishment.isUpdated,
			isUpdateError: establishment.isUpdateError,
			isDeleting: establishment.isDeleting,
			isDeleted: establishment.isDeleted,
			isDeleteError: establishment.isDeleteError,
		})
	);

	// const selectRolesList = createSelector(
	// 	state => state.Roles.roleListSelect,
	// 	roleListSelect => roleListSelect
	// );

	// const roleListSelect = useSelector(selectRolesList);

	const { establishmentList, isLoadingList } = useSelector(
		selectorEstablishments
	);

	useEffect(() => {
		dispatch(getEstablishmentQuery());
	}, []);

	const [dataEstablishment, setDataEstablishment] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Establishment
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = establishment => {
		setDataEstablishment(establishment);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = establishment => {
		setDataEstablishment(establishment);
		handleToggleModal();
	};

	const columns = useMemo(
		() => [
			{
				header: 'Acciones',
				enableSorting: false,
				enableColumnFilter: false,
				enableGlobalFilter: false,
				enableColumnActions: false,
				accessorKey: 'establishment',
				columnDefType: 'display',

				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												onClick={() => {
													const establishmentData =
														cellProps.row.original;
													setIsEdit(true);
													handleClickEdit(establishmentData);
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const establishmentData =
														cellProps.row.original;
													handleClickDelete(establishmentData);
												}}
											>
												<i className='ri-delete-bin-line align-bottom me-2 text-muted'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to={`/establishment/summary/${cellProps.row.original._id}`}
											>
												<i className={`${Icons.idCard} align-bottom me-2 text-muted`}></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
			{ header: 'Nombre', accessorKey: 'name', size: 'auto' },
			{
				header: 'Tipo de establecimiento',
				accessorKey: 'establishment_type.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Etapa de Ciclo Productivo',
				accessorKey: 'productive_cycle_data.productive_cycle_stage_name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					const establishmentTypeCode =
						row.original?.establishment_type?.code;

					// Si establishment_type.code no es "SWE" o "LWE", mostrar "N/A"
					if (establishmentTypeCode !== "SWE" && establishmentTypeCode !== "LWE") {
						return <span span className='badge span-info-color-theme'>No Aplica</span>;
					}

					const stage = row.original?.productive_cycle_stage;

					if (!stage) {
						return <span className='badge span-danger-color-theme'>No Encontrado</span>;
					}

					return (
						<div>
							<span
								className='badge'
								style={{
									backgroundColor: stage.bgcolor,
									color: stage.txcolor,
								}}
							>
								{stage.name}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Estado',
				accessorKey: 'establishment_status.name',
				size: 'auto',
				defaultSort: 'asc',
				dataType: 'multi-select',
				Cell: ({ row }) => {
					let status = row.original.establishment_status;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return (
						<div>
							<span
								className={`badge`}
								style={{ backgroundColor: bgColor, color: txColor }}
							>
								{status ? status.name : 'No Encontrado'}
							</span>
						</div>
					);
				},
			},
			{
				header: 'Tipo de Propiedad',
				accessorKey: 'property_type.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					let status = row?.original?.property_type;
					let bgColor = status?.bgcolor;
					let txColor = status?.txcolor;
					return row?.original?.property_type ? (
						<div>
							<span
								className={status ? `badge` : `badge span-danger-color-theme`}
								style={status ? { backgroundColor: bgColor, color: txColor } : {}}
							>
								{status
									? row.original.property_type.name
									: 'No Encontrado'}
							</span>
						</div>
					) : (
						'-'
					);
				},
			},
			{
				header: 'Centro de Costo',
				accessorKey: 'cost_center.name',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					let costCenter = row?.original?.cost_center;
					return (<span>{costCenter? toSmartTitleCase(costCenter.name): 'No Encontrado'}</span>) 
				},
			},
			{
				header: 'Código SIEP',
				accessorKey: 'code_siep',
				dataType: 'multi-select',
				size: 'auto',
				Cell: ({ row }) => {
					let codeSiep = row?.original?.code_siep;
					const establishmentTypeCode = row.original?.establishment_type?.code;

					// Si establishment_type.code no es "SWE" o "LWE", mostrar "N/A"
					if (establishmentTypeCode !== "SWE" && establishmentTypeCode !== "LWE") {
						return <span>No Aplica</span>;
					}
					return (<span>{codeSiep? codeSiep: 'No Encontrado'}</span>
					) 
				},
			},
			{
				header: 'Código RETC',
				accessorKey: 'code_retc',
				visible: false,
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Código SMA',
				accessorKey: 'code_sma',
				visible: false,
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Código SIDREP',
				accessorKey: 'code_sidrep',
				visible: false,
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Empresa',
				accessorKey: 'company.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Barrio sanitario',
				accessorKey: 'sanitary_vicinity.name',
				dataType: 'multi-select',
				size: 'auto',

				Cell: ({ row }) => {
					const establishmentTypeCode = row.original?.establishment_type?.code;
					const sanitaryVicinity = row.original?.sanitary_vicinity;

					// Si establishment_type.code no es "SWE" o "LWE", mostrar "N/A"
					if (establishmentTypeCode !== "SWE" && establishmentTypeCode !== "LWE") {
						return <span>No Aplica</span>;
					}
		
					return (<span>{sanitaryVicinity? sanitaryVicinity.name: 'No Encontrado'}</span>) 
				},
			},
			{
				header: 'Area productiva',
				accessorKey: 'productive_area.name',
				dataType: 'multi-select',
				size: 'auto',
			},
			{
				header: 'Correo electrónico',
				accessorKey: 'email',
				size: 'auto',
				Cell: ({ row }) => {
					const email = row.original.email;
					return (<span>{email ? email : 'No Encontrado'}</span>);
				},
			},
			{
				header: 'Dirección',
				accessorKey: 'address',
				size: 'auto',
				Cell: ({ row }) => {
					const address = row.original.address;

					if(address == 'N/A'){
						return <span>No Aplica</span>;
					}

					return (<span>{address ? address : 'No Encontrado'}</span>);
				},
			},
			{
				header: 'Latitud',
				accessorKey: 'latitude',
				size: 'auto',
				Cell: ({ row }) => {
					const latitude = row.original.latitude;
					return (<span>{latitude ? latitude : 'No Encontrado'}</span>);
				},
			},
			{
				header: 'Longitud',
				accessorKey: 'longitude',
				size: 'auto',
				Cell: ({ row }) => {
					const longitude = row.original.longitude;
					return (<span>{longitude ? longitude : 'No Encontrado'}</span>);
				},
			},
			// {
			// 	header: 'Desactivado',
			// 	accessorKey: 'disable',
			//
			// 	size: 'auto',
			// 	visible: false,
			// 	Cell: ({ row }) => {
			// 		return (
			// 			<input
			// 				className='form-check-input'
			// 				role='switch'
			// 				type='checkbox'
			// 				id='disabled'
			// 				name='disabled'
			// 				disabled
			// 				checked={row.original.disable}
			// 			/>
			// 		);
			// 	},
			// },
		],
		[handleClickEdit]
	);

	return (
		<React.Fragment>
			<Row>
				<Col lg={12}>
					<Card>
						{/* <CardHeader className='border-0 pb-0'>
							<div className='d-flex align-items-end justify-content-end'>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={() => {
												setIsEdit(false);
												setDataEstablishment({});
												handleToggleModal();
											}}
										>
											<i className={`${Icons.plus} label-icon`}></i>{' '}
											Crear Establecimiento
										</button>
									</div>
								</div>
							</div>
						</CardHeader> */}
						<CardBody className='pt-3'>
							<ODataGrid
								columns={columns}
								getDataFunc={getEstablishmentQuery}
								baseFilters={{
									disable: {
										$eq: false,
									},
								}}
								queryPopulate={[
									'commune',
									'region',
									'company',
									'sanitary_vicinity',
									'management',
									'establishment_status',
									'productive_area',
									'establishment_type',
									'establishment_stage',
									'feeding_barges',
									'crop_type',
									'sensor_failure_status',
									'property_type',
									'cost_center'
								]}
								remoteOperations={{
									pagination: true,
									sorting: true,
									filtering: true,
								}}
								customToolbarActions={[
									{
										label: 'Crear',
										icon: Icons.plus,
										onClick: () => {
											setIsEdit(false);
											setDataEstablishment({});
											handleToggleModal();
										},
										title: 'Crear Nuevo Establecimiento'
									}
								]}
								nameFile={'establecimiento'}
							/>
						</CardBody>
					</Card>
				</Col>
			</Row>

			<AddEditEstablishmentModal
				dataEstablishment={dataEstablishment}
				isEdit={isEdit}
				isOpen={modal}
				handleToggleModal={handleToggleModal}
				activeTab={activeTab}
				toggleTab={toggleTab}
			/>
			<DeleteEstablishmentModal
				dataEstablishment={dataEstablishment}
				isOpen={modalDelete}
				handlerToggleModal={handleToggleModalDelete}
			/>
		</React.Fragment>
	);
};

export default EstablishmentsList;
